/* eslint-disable prefer-spread */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { stringify } from '../utils/service.utils';

/** The core logging methods of the Logger Service. Matches the core logging methods of browser console. */
export interface Logger {
  debug(message?: any, ...optionalParams: any[]): void;
  info(message?: any, ...optionalParams: any[]): void;
  log(message?: any, ...optionalParams: any[]): void;
  error(message?: any, ...optionalParams: any[]): void;
  warn(message?: any, ...optionalParams: any[]): void;
}

export enum LogType {
  Log = 'log',
  Debug = 'debug',
  Error = 'error',
  Info = 'info',
  Warn = 'warn',
}

export interface LogEntry {
  type: LogType;
  entry: string;
}

/** Log messages, warnings, errors */
@Injectable({ providedIn: 'root' })
export class LoggerService implements Logger {
  public entries$: Observable<LogEntry>;
  private entriesSubject$: Subject<LogEntry>;

  constructor() {
    this.entriesSubject$ = new Subject<LogEntry>();
    this.entries$ = this.entriesSubject$.asObservable();
  }

  log(message?: any, ...optionalParams: any[]) {
    const args = [message, ...optionalParams];
    console.log.apply(console, args);
    this.nextEntry(LogType.Log, args);
  }

  debug(message?: any, ...optionalParams: any[]) {
    const args = [message, ...optionalParams];
    console.debug ? console.debug.apply(console, args) : console.log.apply(console, args);
    this.nextEntry(LogType.Debug, args);
  }

  error(message?: any, ...optionalParams: any[]) {
    const args = [message, ...optionalParams];
    console.error.apply(console, args);
    this.nextEntry(LogType.Error, args);
  }

  info(message?: any, ...optionalParams: any[]) {
    const args = [message, ...optionalParams];
    console.info.apply(console, args);
    this.nextEntry(LogType.Info, args);
  }

  warn(message?: any, ...optionalParams: any[]) {
    const args = [message, ...optionalParams];
    console.warn.apply(console, args);
    this.nextEntry(LogType.Warn, args);
  }

  private nextEntry(type: LogType, args: any[]) {
    this.entriesSubject$.next({
      type: type,
      entry: stringify(args).join('\n'),
    });
  }
}
